const APP = 'dataBinding'
const TYPE = 'viewerStatusForEditor'

type ComponentPropertiesConnectedToEmptyFields = {
  propertyToField: Record<string, string>
  includesPrimaryProperty: boolean
}

export type ViewerStatus = {
  datasetSize: Record<string, number>
  componentToPropertiesConnectedToEmptyFields: Record<string, ComponentPropertiesConnectedToEmptyFields>
}

export const createSenderOfViewerStatusForEditor = ({
  global,
  postMessage,
  enabled,
}: {
  global: any
  postMessage: (message: any) => void
  enabled: boolean
}) => {
  const viewerStatus: ViewerStatus = {
    datasetSize: {},
    componentToPropertiesConnectedToEmptyFields: {},
  }
  if (global._dataBindingViewerStatusForEditorInterval) {
    global.clearInterval(global._dataBindingViewerStatusForEditorInterval)
  }
  if (enabled) {
    global._dataBindingViewerStatusForEditorInterval = global.setInterval(
      () => {
        postMessage({
          app: APP,
          type: TYPE,
          message: JSON.stringify(viewerStatus),
        })
      },
      1000,
    )
  }
  return {
    update: (fn: (viewerStatus: ViewerStatus) => void) => {
      if (enabled) {
        fn(viewerStatus)
      }
    },
  }
}
